/**
 * API client for the Operation Dashboard summary endpoint.
 */
import { format } from 'date-fns';
import api from '../../services/api';
import { DashboardFilters } from '../Dashboard/DashboardFilterBar';
import type { OperationSummaryResponse, BrandBreakdownResponse, SeverityBrandsResponse, Quadrant } from './types';


function csv(values: string[] | undefined): string | undefined {
  return values && values.length > 0 ? values.join(',') : undefined;
}


export async function fetchOperationSummary(
  filters: DashboardFilters
): Promise<OperationSummaryResponse> {
  const params = {
    from_date: format(filters.fromDate, 'yyyy-MM-dd'),
    to_date: format(filters.toDate, 'yyyy-MM-dd'),
    brands: csv(filters.brands),
    categories: csv(filters.categories),
    stores: csv(filters.stores),
    cities: csv(filters.cities),
  };
  const resp = await api.getOperationDashboardSummary(params);
  return resp.data;
}

export async function fetchQuadrantBrandBreakdown(
  quadrant: Quadrant,
  filters: DashboardFilters
): Promise<BrandBreakdownResponse> {
  const params = {
    quadrant,
    from_date: format(filters.fromDate, 'yyyy-MM-dd'),
    to_date: format(filters.toDate, 'yyyy-MM-dd'),
    brands: csv(filters.brands),
    categories: csv(filters.categories),
    stores: csv(filters.stores),
    cities: csv(filters.cities),
  };
  const resp = await api.getOperationDashboardBreakdown(params);
  return resp.data;
}

export async function fetchSeverityBrands(
  quadrant: Quadrant,
  filters: DashboardFilters
): Promise<SeverityBrandsResponse> {
  const params = {
    quadrant,
    from_date: format(filters.fromDate, 'yyyy-MM-dd'),
    to_date: format(filters.toDate, 'yyyy-MM-dd'),
    brands: csv(filters.brands),
    categories: csv(filters.categories),
    stores: csv(filters.stores),
    cities: csv(filters.cities),
  };
  const resp = await api.getOperationDashboardSeverityBrands(params);
  return resp.data;
}
